<template>
	<div class="full">
		<el-container class="full">
			<el-container>
				<!-- <el-aside width="200px">Aside</el-aside> -->
				<el-container>
					<el-main>
						<div class="table">
							<vxe-form :data="formData" @submit="submitEvent" @reset="reset">
								<!-- 								<vxe-form-item title="店铺名称" field="shopname" :item-render="{}">
									<template #default="{ data }">
										<el-select size="mini" v-model="data.shopname" placeholder="请选择">
											<el-option value="所有店铺" label="所有店铺"></el-option>
											<el-option v-for="(item,index) in formField.shopname"
												:key="index + Math.random()" :label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</template>
								</vxe-form-item> -->
								<vxe-form-item title="名称" field="targetstaffid" :item-render="{}">
									<template #default="{ data }">
										<el-select size="mini" v-model="data.targetstaffid" placeholder="请选择" clearable>
											<el-option v-for="(item,index) in formField.targetstaffid"
												:key="index + Math.random()" :label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</template>
								</vxe-form-item>
								<!-- 								<vxe-form-item title="日期" field="shopname" :item-render="{}">
									<template #default="{ data }">
										<datePicker :sequence="false" v-model="data.date" />
									</template>
								</vxe-form-item> -->
								<vxe-form-item>
									<template #default>
										<vxe-button type="submit" status="primary">查询</vxe-button>
										<vxe-button type="reset">重置</vxe-button>
									</template>
								</vxe-form-item>
							</vxe-form>
							<!-- 							<vxe-toolbar ref="toolbar" export refresh custom>
								<template #buttons>
									<datePicker :sequence="false" type="date" v-model="downloaddate" />
									<vxe-button style="margin-left: 10px;" @click="downloadcurentday" status="primary">
										日数据下载</vxe-button>
								</template>
							</vxe-toolbar> -->
							<vxe-table border :row-config="{isCurrent: true, isHover: true}" id="bi_bisummary"
								@cell-click="cellClickEvent" ref="bisummary" :data="tableData" height="80%"
								:column-config="{isCurrent: true, isHover: true}" :show-footer="false"
								:footer-method="footerMethod" :export-config="{}" :custom-config="customConfig">
								<vxe-column fixed="left" field="static_time" title="最近登记日期">
									<template #default="{ row }">
										<span>{{$systemMethods.timestampToDate(row.static_time,true)}}</span>
									</template>
								</vxe-column>
								<vxe-column fixed="left" field="targetstaffid" title="名称">
									<template #default="{ row }">
										<span>{{$systemMethods.getstaff(row.targetstaffid)}}</span>
									</template>
								</vxe-column>
								<vxe-column fixed="left" field="entry_time" title="入职日期">
									<template #default="{ row }">
										<span>{{$systemMethods.timestampToDate(row.entry_time,true)}}</span>
									</template>
								</vxe-column>
								<vxe-column field="validReplyUv1d" title="有效接待人数" sortable></vxe-column>
								<vxe-column field="realPayAmt1d" title="净销售额" sortable></vxe-column>
								<vxe-column field="conversionrate" title="转换率(%)" sortable></vxe-column>
								<vxe-column field="fstReplyDur1d" title="首响" sortable></vxe-column>
								<vxe-column field="avgReplyDur1d" title="平响" sortable></vxe-column>
							</vxe-table>
						</div>
						<div class="chart">
							<div class="full flex" style="flex-direction: column;">
								<el-radio-group size="mini" v-model="chartField" style="margin: 10px 0;">
									<el-radio-button label="validReplyUv1d">有效接待人数</el-radio-button>
									<el-radio-button label="realPayAmt1d">净销售额</el-radio-button>
									<el-radio-button label="conversionrate">转换率</el-radio-button>
									<el-radio-button label="fstReplyDur1d">首响</el-radio-button>
									<el-radio-button label="avgReplyDur1d">平响</el-radio-button>
								</el-radio-group>
								<div style="flex: 1;position: relative;">
									<statistics-chart ref="statisticsChart" :chartField="chartField"
										:chartTitle="chartTitle" :kpi="kpi" :formData="formData" :tableData="tableData" />
								</div>
							</div>
						</div>
					</el-main>
				</el-container>
			</el-container>
		</el-container>

	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 50%;
	}

	.chart {
		position: relative;
		width: 100%;
		height: 50%;
	}
</style>
<script>
	// import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	import statisticsChart from './statistics.vue'
	export default {
		name: 'bi',
		props: {

		},
		data() {
			return {
				downloaddate: null,
				tableData: [],
				formField: {
					targetstaffid: []
				},
				formData: {
					targetstaffid: '',
				},
				chart: null,
				date: '',
				customConfig: {
					storage: true
				},
				chartTitle:'有效接待人数',
				chartField: 'validReplyUv1d',
				kpi:[]

			}
		},
		watch: {
			chartField(e) {
				console.log(e)
				this.createChart()
			}
		},
		created() {

		},
		mounted() {
			this.currrentdate()
			this.list()
			this.$nextTick(() => {
				this.$refs.bisummary.connect(this.$refs.toolbar)
			})
		},
		computed: {

		},

		methods: {
			list() {
				this.$api.BIStafflifecycle.get(this.formData).then((res) => {
					this.tableData = res.tableData
					this.kpi = res.kpi
					this.formField.targetstaffid = res.formField.map((item) => {
						return {
							value: item,
							label: this.$systemMethods.getstaff(item)
						}
					})
					this.createChart()
				})
			},
			downloadcurentday() {
				let data = []
				this.$api.BIsummary.downcurrentday({
					date: this.downloaddate / 1000
				}).then((res) => {
					res.forEach((item) => {
						data.push({
							psnNickName: item.psnNickName,
							shopname: item.shopname,
							validReplyUv1d: item.validReplyUv1d,
							fstReplyDur1d: item.fstReplyDur1d,
							avgReplyDur1d: item.avgReplyDur1d,
							dateId: item.dateId
						})
					})

					this.$refs.bisummary.exportData({
						filename: '客服绩效',
						type: 'xlsx',
						isHeader: true,
						isFooter: false,
						columns: ['psnNickName', 'shopname', 'validReplyUv1d', 'fstReplyDur1d',
							'avgReplyDur1d', 'dateId'
						],
						data: data
					})
					console.log(data)
				})
			},
			currrentdate() {
				// let today = new Date()
				// let currentTimestamp = today.getTime()
				// let preday1 = 24 * 60 * 60 * 1000 * 1
				// preday1 = currentTimestamp - preday1
				// let preday7 = 24 * 60 * 60 * 1000 * 7
				// preday7 = currentTimestamp - preday7
				// this.formData.date = [preday7, preday1]
				// this.downloaddate = preday1
			},
			footerMethod({
				data,
				columns
			}) {
				//console.log(columns)
				let validReplyUv1d = 0
				let cstUsrCnt1d = 0
				//let ordUsrCnt1d = 0
				let ordCstUsrCnt1d = 0
				let ordAmt1d = 0
				let payUsrCnt1d = 0
				let payAmt1d = 0
				// let payItmCnt1d = 0
				let payCnt1d = 0
				// let proportionCss = 0
				let rfdAmt1d = 0
				let realPayAmt1d = 0
				let fstReplyDur1d = 0
				let avgReplyDur1d = 0
				data.forEach((item) => {
					validReplyUv1d += item.validReplyUv1d ? parseFloat(item.validReplyUv1d) : 0

					fstReplyDur1d += item.fstReplyDur1d * item.validReplyUv1d
					avgReplyDur1d += item.avgReplyDur1d * item.validReplyUv1d

					cstUsrCnt1d += item.cstUsrCnt1d ? parseFloat(item.cstUsrCnt1d) : 0
					ordCstUsrCnt1d += item.ordCstUsrCnt1d ? parseFloat(item.ordCstUsrCnt1d) : 0
					ordAmt1d += item.ordAmt1d ? parseFloat(item.ordAmt1d) : 0
					payUsrCnt1d += item.payUsrCnt1d ? parseFloat(item.payUsrCnt1d) : 0
					payAmt1d += item.payAmt1d ? parseFloat(item.payAmt1d) : 0
					// payItmCnt1d += item.payItmCnt1d ? parseFloat(item.payItmCnt1d) : 0
					payCnt1d += item.payCnt1d ? parseFloat(item.payCnt1d) : 0
					// proportionCss += item.proportionCss ? parseFloat(item.proportionCss) : 0
					rfdAmt1d += item.rfdAmt1d ? parseFloat(item.rfdAmt1d) : 0
					realPayAmt1d += item.realPayAmt1d ? parseFloat(item.realPayAmt1d) : 0
				})
				let footer = {
					shopname: '合计',
					psnNickName: '-',
					validReplyUv1d: validReplyUv1d,
					cstUsrCnt1d: cstUsrCnt1d,
					ordCstUsrCnt1d: ordCstUsrCnt1d,
					ordAmt1d: ordAmt1d.toFixed(2),
					payUsrCnt1d: payUsrCnt1d,
					payAmt1d: payAmt1d.toFixed(2),
					payCnt1d: payCnt1d,
					rfdAmt1d: rfdAmt1d.toFixed(2),
					realPayAmt1d: realPayAmt1d.toFixed(2),
					fstReplyDur1d: (fstReplyDur1d / validReplyUv1d).toFixed(2),
					avgReplyDur1d: (avgReplyDur1d / validReplyUv1d).toFixed(2),
					conversionrate: (ordCstUsrCnt1d / cstUsrCnt1d * 100).toFixed(2)

				}
				let showFooter = []
				columns.forEach((item) => {
					if (footer[item.field]) {
						showFooter.push(footer[item.field])
					}
				})
				return [
					showFooter
				]
			},
			submitEvent() {
				this.list()
			},
			reset() {
				for (let i in this.formData) {
					this.formData[i] = null
				}
				this.currrentdate()
				this.formData.shopname = '所有店铺'
				this.list()
			},
			headerCellClickEvent(e) {
				let filterIndex = this.filterField.findIndex((item) => {
					return item == e.column.field
				})
				if (filterIndex === -1) {
					if (!e.triggerSort) {
						this.chartField = e.column.field
						this.chartTitle = e.column.title
						this.createChart()
					}
				}
			},
			cellClickEvent() {

			},
			createChart() {
				this.$nextTick(() => {
					this.$refs.statisticsChart.createChart()
				})
			}
		},
		components: {
			//datePicker,
			statisticsChart
		}
	}
</script>